import {
  BatchStatisticsBestReaderConditionListItem,
  BatchStatisticsBestReaderConditionListItemFromJSON
} from '@/api/models/batch/BatchStatisticsBestReaderConditionListItem'

export interface BatchStatisticsBestReaderSelectItemResult {
  items: BatchStatisticsBestReaderConditionListItem
}

export function BatchStatisticsBestReaderSelectItemResultFromJSON(
  json: any
): BatchStatisticsBestReaderSelectItemResult {
  return {
    items: BatchStatisticsBestReaderConditionListItemFromJSON(json)
  }
}
